module.exports = __webpack_public_path__ + "img/swiper_3.5_1_2.2a95a337.webp";